import { m } from "@estate-platform/i18n/messages";
import { Skeleton } from "@estate-platform/ui/skeleton";

import type { ReactElement, ReactNode } from "react";

const rowKeys = ["first", "second", "third", "fourth", "fifth"] as const;

export const SkeletonPage = ({ children }: { readonly children: ReactNode }): ReactElement => (
  <div role="status" aria-label={m.loading()} className="flex flex-col gap-6">
    {children}
  </div>
);

export const SkeletonHeading = (): ReactElement => <Skeleton shape="line" width="12rem" height="1.75rem" />;

export const SkeletonLines = (): ReactElement => (
  <div className="flex max-w-180 flex-col gap-3">
    {rowKeys.map((key, index) => (
      <Skeleton key={key} shape="line" width={`${String(100 - index * 12)}%`} />
    ))}
  </div>
);

export const PendingPage = (): ReactElement => (
  <div className="p-4 expanded:px-10 expanded:py-8">
    <SkeletonPage>
      <SkeletonHeading />
      <SkeletonLines />
    </SkeletonPage>
  </div>
);
